export const FileUploadItem = {
	key: "image",
	label: "Mobil Banner",
	dimensions: "1905x980",
	fileSize: "10485760",
	fileSizeText: "10MB",
	format: "JPEG, JPG",
	default: "imageUrl",
	isRequired: true,
};
